
/* eslint-disable @typescript-eslint/no-shadow */
export namespace SpocManagementSortOrder {
  export enum SpocManagementSortOrder {
    ASCENDING = "ASCENDING",
    DESCENDING = "DESCENDING",
  }

  export interface SpocManagementSortOrderDTO {
    case: string;
  }

  export const fromDTO = (dto: SpocManagementSortOrderDTO): SpocManagementSortOrder => {
    if (dto === undefined || dto === null) {
      throw new InvalidSpocManagementSortOrderError(
        `Invalid DTO ${dto} provided for SpocManagementSortOrder.SpocManagementSortOrder`
      );
    }
    switch (dto.case) {
      case "ASCENDING":
        return SpocManagementSortOrder.ASCENDING;
      case "DESCENDING":
        return SpocManagementSortOrder.DESCENDING;
      default:
        throw new InvalidSpocManagementSortOrderError(
          `Case ${dto.case} is not valid case of SpocManagementSortOrder.SpocManagementSortOrder`
        );
    }
  };

  export const toDTO = (spocManagementSortOrder: SpocManagementSortOrder): SpocManagementSortOrderDTO => {
    const enumDTO = {
      case: SpocManagementSortOrder[spocManagementSortOrder],
    };
    return enumDTO;
  };
}

export class InvalidSpocManagementSortOrderError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocManagementSortOrderError";
  }
}
export class InvalidSpocManagementSortOrderAscendingError extends InvalidSpocManagementSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocManagementSortOrderAscendingError";
  }
}

export class InvalidSpocManagementSortOrderDescendingError extends InvalidSpocManagementSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocManagementSortOrderDescendingError";
  }
}
